import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { AI_ASSISTANT_ITEMS } from 'constants/AI';
import { BusinessPlanAIApi } from 'services/businessPlanAI/businessPlanAI.api';

import { ObjectValues } from 'helpers/types';

export const aiRequestOption = {
  [AI_ASSISTANT_ITEMS.GENERATE]: BusinessPlanAIApi.generateField,
  [AI_ASSISTANT_ITEMS.IMPROVE]: BusinessPlanAIApi.improveField,
  [AI_ASSISTANT_ITEMS.SHORTER]: BusinessPlanAIApi.shorter,
  [AI_ASSISTANT_ITEMS.LONGER]: BusinessPlanAIApi.longer,
  [AI_ASSISTANT_ITEMS.FIX_GRAMMAR]: BusinessPlanAIApi.fixGrammar,
};

export const AI_ASSISTANT_ERRORS = {
  NOT_ENOUGH_CONTEXT: 'NOT_ENOUGH_CONTEXT',
  NOT_ENOUGH_CONTEXT_FOR_ONE_PAGE: 'NOT_ENOUGH_CONTEXT_FOR_ONE_PAGE',
  MISSING_CONTENT: 'MISSING_CONTENT',
  MISSING_BUSINESS_PLAN_ID: 'MISSING_BUSINESS_PLAN_ID',
  DEFAULT: 'DEFAULT',
} as const;

export type IAIAssistantErrorTypes = ObjectValues<typeof AI_ASSISTANT_ERRORS>;
export type IAIAssistantError = { title: string; message: string };
export type IAIAssistantErrors = Record<IAIAssistantErrorTypes, IAIAssistantError>;

export const createAIErrorObject = (title: string, message: string) => {
  return { title, message };
};

export const useAiErrors = () => {
  const { t, i18n } = useTranslation();
  return useMemo(() => {
    const aiErrors: IAIAssistantErrors = {
      [AI_ASSISTANT_ERRORS.NOT_ENOUGH_CONTEXT]: createAIErrorObject(
        t('aiGenerationErrors.notEnoughContext'),
        t('aiGenerationErrors.pleaseFillRequiredFieldsInOverview'),
      ),
      [AI_ASSISTANT_ERRORS.NOT_ENOUGH_CONTEXT_FOR_ONE_PAGE]: createAIErrorObject(
         t('aiGenerationErrors.notEnoughContext'),
        t('aiGenerationErrors.pleaseFillRequiredFields'),
      ),
      [AI_ASSISTANT_ERRORS.MISSING_CONTENT]: createAIErrorObject(
        '',
         t('aiGenerationErrors.pleaseTypeInOrGenerateFirst'),
      ),
      [AI_ASSISTANT_ERRORS.MISSING_BUSINESS_PLAN_ID]: createAIErrorObject('',  t('aiGenerationErrors.businessPlanIdMissing'),),
      [AI_ASSISTANT_ERRORS.DEFAULT]: createAIErrorObject(t('aiGenerationErrors.error'), t('aiGenerationErrors.somethingWentWrong'),),
    };
    return aiErrors;
  }, [t, i18n]);
};

